import { useEffect } from 'react';

const useOutsideClick = (ref, setter) => {
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				setter(false); // Close the modal when clicking outside
			}
		};

		document.addEventListener('pointerdown', handleClickOutside);
		return () => {
			document.removeEventListener('pointerdown', handleClickOutside);
		};
	}, [ref, setter]); // Add setter to dependency array
};

export default useOutsideClick;
